'use strict';

const _=require('pulsar-utils/dist-es6/_');
const timespan=require('pulsar-utils/dist-es6/time/timespan');

const ZeroDuration=timespan.fromMilliseconds(0);let

HosStatusDurations=class HosStatusDurations{
constructor(offDuty=ZeroDuration,sleeperBerth=ZeroDuration,driving=ZeroDuration,onDuty=ZeroDuration,drivingOffDuty=ZeroDuration){
_.ensureInstanceOf(timespan.TimeSpan,offDuty);
_.ensureInstanceOf(timespan.TimeSpan,sleeperBerth);
_.ensureInstanceOf(timespan.TimeSpan,driving);
_.ensureInstanceOf(timespan.TimeSpan,onDuty);
_.ensureInstanceOf(timespan.TimeSpan,drivingOffDuty);

this._offDuty=offDuty;
this._sleeperBerth=sleeperBerth;
this._driving=driving;
this._onDuty=onDuty;
this._drivingOffDuty=drivingOffDuty;
}

get offDuty(){
return this._offDuty;
}

get sleeperBerth(){
return this._sleeperBerth;
}

get driving(){
return this._driving;
}

get onDuty(){
return this._onDuty;
}

get drivingOffDuty(){
return this._drivingOffDuty;
}

toJSON(){
return{
offDuty:this._offDuty.totalMilliseconds(),
sleeperBerth:this._sleeperBerth.totalMilliseconds(),
driving:this._driving.totalMilliseconds(),
onDuty:this._onDuty.totalMilliseconds(),
drivingOffDuty:this._drivingOffDuty.totalMilliseconds()};

}

static fromJSON(jsonStatusDurations){
return new HosStatusDurations(
timespan.fromMilliseconds(jsonStatusDurations.offDuty),
timespan.fromMilliseconds(jsonStatusDurations.sleeperBerth),
timespan.fromMilliseconds(jsonStatusDurations.driving),
timespan.fromMilliseconds(jsonStatusDurations.onDuty),
timespan.fromMilliseconds(jsonStatusDurations.drivingOffDuty));
}

static fromPoints(hosPoints,endTime,{json=!1}={}){
let durationsObject=new HosStatusDurations().toJSON();

if(hosPoints.length>0){
const unixEndTime=endTime.getTime();

durationsObject=_(hosPoints).
map(({time,value})=>({time:time.getTime(),value})).
sortBy(tsp=>tsp.time).
filter(tsp=>tsp.time<=unixEndTime).
concat({time:unixEndTime,value:'END'}).
reduce((durations,tsp,index,points)=>{
if(index===0){
return durations;
}

durations[_.lowerFirst(points[index-1].value.status.name)]+=tsp.time-points[index-1].time;

return durations;
},durationsObject);
}

return json===!0?
durationsObject:
HosStatusDurations.fromJSON(durationsObject);
}};


module.exports=HosStatusDurations;
//# sourceMappingURL=hosStatusDurations.js.map
